import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/** Moduli */
import { CoreSharedUiModule } from '@kodit/core/shared-ui';
import { HttpClientModule } from '@angular/common/http';

/** PrimeNg */
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { InputMaskModule } from 'primeng/inputmask';
import { ToolbarModule } from 'primeng/toolbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { FileUploadModule } from 'primeng/fileupload';
import { PanelModule } from 'primeng/panel';
import { InplaceModule } from 'primeng/inplace';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { EditorModule } from 'primeng/editor';
import { SplitButtonModule } from 'primeng/splitbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { GalleriaModule } from 'primeng/galleria';
import { CarouselModule } from 'primeng/carousel';
import { DataViewModule } from 'primeng/dataview';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DividerModule } from 'primeng/divider';
import { StepsModule } from 'primeng/steps';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';
import { ImageModule } from 'primeng/image';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AccordionModule } from 'primeng/accordion';
import { ChipsModule } from 'primeng/chips';

@NgModule({
  imports: [],
  exports: [
    CommonModule,
    FormsModule, // ToDo: remove this one after detailed search refactoring
    ReactiveFormsModule,
    CoreSharedUiModule,
    HttpClientModule,
    FieldsetModule,
    InputMaskModule,
    CheckboxModule,
    DialogModule,
    CheckboxModule,
    CalendarModule,
    ScrollPanelModule,
    ChartModule,
    AutoCompleteModule,
    InputNumberModule,
    KeyFilterModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    ButtonModule,
    ToolbarModule,
    CardModule,
    TabViewModule,
    SelectButtonModule,
    TableModule,
    MultiSelectModule,
    ChipsModule,
    PasswordModule,
    FileUploadModule,
    PanelModule,
    InplaceModule,
    InputTextareaModule,
    EditorModule,
    SplitButtonModule,
    RadioButtonModule,
    GalleriaModule,
    CarouselModule,
    DataViewModule,
    MessagesModule,
    MessageModule,
    DividerModule,
    StepsModule,
    BlockUIModule,
    SkeletonModule,
    ProgressSpinnerModule,
    ImageModule,
    OverlayPanelModule,
    AccordionModule,
  ],
  declarations: [],
})
export class CoreSharedModule {}
